import { render, staticRenderFns } from "./TheBudgetTable.vue?vue&type=template&id=22f262bd"
import script from "./TheBudgetTable.vue?vue&type=script&lang=js"
export * from "./TheBudgetTable.vue?vue&type=script&lang=js"
import style0 from "./TheBudgetTable.vue?vue&type=style&index=0&id=22f262bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports